/** Width shared between the tenant/AM dropdown wrapper and the search bar. */
export const TOPBAR_SEARCH_WIDTH = { desktop: 240, tablet: 160 } as const;

/** MUI Select sx overrides that match the topbar search bar's visual style. */
export const topbarSelectSx = {
  height: 32,
  fontSize: 13,
  bgcolor: "var(--bg-elev)",
  borderRadius: "var(--r-sm)",
  color: "var(--ink-3)",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--line)",
    transition: "border-color 100ms",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--line-strong)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--line-strong)",
    borderWidth: "1px",
  },
  "& .MuiSelect-select": {
    padding: "0 32px 0 10px",
    display: "flex",
    alignItems: "center",
  },
} as const;
